export default "__VITE_ASSET__CKWMkGQW__"